export interface VelocityLimitListFilter {
  page?: number | null;
  count?: number | null;
  sort_key?: string | null;
  sort_by?: string | null;
  search?: string | null;
}

export const defaultVelocityLimitListFilter: VelocityLimitListFilter = {
  page: 0,
  count: 10,
  sort_key: '',
  sort_by: '',
  search: '',
};
